/* NIDO · scripts mínimos */
(function () {
  // Actualiza el precio al cambiar de variante
  var select = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-product-price]');
  if (select && priceEl) {
    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (opt && opt.getAttribute('data-price')) { priceEl.innerHTML = opt.getAttribute('data-price'); }
      var btn = document.querySelector('[data-add-button]');
      if (btn) {
        var avail = opt.getAttribute('data-available') === 'true';
        btn.disabled = !avail;
        btn.textContent = avail ? 'Añadir al carrito' : 'Agotado';
      }
    });
  }
  // Cierra el menú móvil al navegar
  document.querySelectorAll('.mobile-nav a').forEach(function (a) {
    a.addEventListener('click', function () {
      var d = document.querySelector('.menu-toggle');
      if (d) { d.removeAttribute('open'); }
    });
  });
})();
